// plugins/loading.ts
export default defineNuxtPlugin(() => {
  const { show, close } = useAlert()

  return {
    provide: {
      alert: {
        show,
        close,
      },
    },
  }
})
